module.exports = __webpack_public_path__ + "img/back_1000.897a1aae.png";